// extracted by mini-css-extract-plugin
export default {"newsBox":"news_newsBox__NIgz-","rowBox":"news_rowBox__J3RPt","resetBox":"news_resetBox__9mBUJ"};